import React from 'react';
import SvgIcon from './SvgIcon';

const ComingSoonStar = props => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Under-Construction-Template" transform="translate(-694.000000, -848.000000)" fillRule="nonzero">
                    <g id="Placeholder" transform="translate(497.000000, 277.000000)">
                        <g id="Release-Date" transform="translate(197.000000, 567.000000)">
                            <g id="Group-4">
                                <g id="coming_soon_cute_star" transform="translate(0.000000, 4.000000)">
                                    <circle id="Oval-2" fill="#FFC89B" cx="10" cy="10" r="10"></circle>
                                    <g id="ic_star_24px" transform="translate(5.000000, 5.000000)" fill="#FFFFFF">
                                        <polygon
                                            id="Shape"
                                            points="5 7.635 8.09 9.5 7.27 5.985 10 3.62 6.405 3.315 5 0 3.595 3.315 0 3.62 2.73 5.985 1.91 9.5"
                                        ></polygon>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </SvgIcon>
    );
};

ComingSoonStar.displayName = 'ComingSoonStarIcon';

export default ComingSoonStar;
